<template>
    <nav id="menu-top-portrait" :class="[{ offline: !conn }, { printer: printing }, { 'auditor-location-menu-open': canAuditorChangeLocal && auditorLocationMenuOpen }, { 'menu-top-portrait--auditor-local': isAuditorSession }, { 'has-andy-agents': showAndyAgents }]">
        <!-- MENU ICON -->
        <div class="menu-icon" @click="toggleMenu" :class="{ renew: renewLicense || withAlerts }"></div>

        <!-- OFFLINE ICON -->
        <div class="offline-icon" v-if="!conn && !printing"></div>

        <!-- Local + ID en móvil: auditores (siempre) o pantallas /audit (empleado de tienda); "Cambiar de local" solo sesión auditor -->
        <template v-if="showAuditorLocationHeader">
            <div class="title-menu auditor-location" :class="{ offline: !conn && !printing, sync: !printing && showSync }">
                <div class="auditor-location-trigger" :class="{ 'is-readonly': !canAuditorChangeLocal }" @click.stop="onAuditorLocationHeaderClick">
                    <div class="auditor-location-name">{{ auditorLocationName }}</div>
                    <div
                        class="auditor-location-id"
                        :class="{
                            opened: canAuditorChangeLocal && auditorLocationMenuOpen,
                            'auditor-location-id--static': !canAuditorChangeLocal
                        }"
                    >
                        <span class="auditor-location-id-text">ID: {{ auditorLocationIdentification }}</span>
                        <span v-if="canAuditorChangeLocal" class="auditor-location-caret" aria-hidden="true"></span>
                    </div>
                </div>
            </div>
            <template v-if="canAuditorChangeLocal">
                <div v-if="auditorLocationMenuOpen" class="auditor-location-backdrop" @click="closeAuditorLocationMenu"></div>
                <div v-if="auditorLocationMenuOpen" class="auditor-location-dropdown-sheet" @click="closeAuditorLocationMenu">
                    <div class="auditor-location-dropdown" @click.stop>
                        <div class="auditor-location-option" @click.stop="changeLocalFromAuditorHeader">
                            <div class="icon"></div>
                            <div class="text">{{ $t('user.change_local') }}</div>
                        </div>
                    </div>
                </div>
            </template>
        </template>

        <!-- CUSTOMER LOGO / CURRENT PAGE -->
        <template v-else-if="$route.name == 'Home'">
            <router-link class="customer-logo" :to="redirectPath('/home')" :style="{ backgroundImage: 'url(' + clientLogo + ')' }"></router-link>
        </template>

        <template v-else>
            <div class="title-menu" :class="{ offline: !conn && !printing, sync: !printing && showSync }">
                <div class="sub-menu" v-if="$route.name == 'ConfigPage' || $route.name == 'TemplateItems'" @click="SubMenuToggle()">
                    <div class="title">{{ $t('menu_tools.config_title') }}</div>
                    <div :class="{ opened: openedSubMenu }" class="sub-title">
                        <template v-if="$route.path == '/config/templates' || $route.path.startsWith('/config/templates/')">{{ $t('config.templates.title') }}</template>
                        <template v-else-if="$route.path == '/config/location'">{{ $t('config.location.title') }}</template>
                        <template v-else-if="$route.path == '/config/printer'">{{ $t('config.printer.title') }}</template>
                        <template v-else-if="$route.path == '/config/sensconfig'">{{ $t('config.sensor.title') }}</template>
                        <template v-else-if="$route.path == '/config/dashboard'">{{ $t('config.dashboard.title') }}</template>
                        <template v-else-if="$route.path == '/config/users'">{{ $t('config.users.title') }}</template>
                        <template v-else-if="$route.path == '/config/status'">{{ $t('config.status.title') }}</template>
                    </div>
                </div>

                <h5 v-else class="page-title" @click="toCurrentRoute">{{ pageTitle }}</h5>
            </div>
        </template>

        <!-- PRINTER ICON -->
        <div class="printer-icon" v-if="printing && !showSync" @click="openPrintQueue()"></div>

        <!-- SYNC -->
        <div class="sync-icon" v-else-if="!printing && showSync" @click="openStatusPage()"></div>

        <div class="header-actions">
            <!-- AI AGENT MASCOT BUTTON -->
            <button v-if="showAndyAgents" type="button" class="andy-agents-button" :aria-label="$t('page_title.AndyAgents')" @click="openAndyAgents">
                <AndyMascot decorative />
            </button>

            <!-- USER -->
            <div class="user-avatar" v-if="user" @click="toggleUser">
                <img class="main-img" v-bind:src="user.avatar.includes('//') ? user.avatar : css_image_url + 'avatar/' + user.avatar" />
            </div>
        </div>
    </nav>
</template>

<script>
import mixin from '@/core/mixin'
import auditorChangeLocal from '@/mixins/auditorChangeLocal'
import AndyMascot from '@/components/domain/ui/AndyMascot.vue'

export default {
    components: { AndyMascot },
    mixins: [mixin, auditorChangeLocal],
    data() {
        return {
            auditorLocationMenuOpen: false
        }
    },
    computed: {
        /** Misma idea que App.vue: sesión auditor (incl. setAuditorLogin(true) tras login) */
        isAuditorSession() {
            return !!(this.$store.getters.isAuditorLogin || this.$store.getters['loginUser/getAuditor'])
        },
        showAndyAgents() {
            return !!this.emp_id && !this.isAuditorSession
        },
        isAuditRoute() {
            const n = this.$route.name
            return n === 'Audit' || n === 'AuditDetail' || n === 'AuditEdit'
        },
        /** Muestra nombre + ID: auditores en cualquier ruta; empleados de tienda solo en /audit */
        showAuditorLocationHeader() {
            return this.isAuditorSession && this.isAuditRoute
        },
        canAuditorChangeLocal() {
            return this.isAuditorSession
        },
        auditorLocation() {
            const loc = this.$store.getters['loginUser/getLocalLocation']
            if (loc && typeof loc === 'object' && Object.keys(loc).length > 0) {
                return loc
            }
            return this.$store.getters['login/getLocation'] || {}
        },
        auditorLocationName() {
            const name = this.auditorLocation.name
            return name != null && String(name).length > 0 ? String(name).toUpperCase() : '-'
        },
        auditorLocationIdentification() {
            const id = this.auditorLocation.identification
            return id != null && String(id).length > 0 ? String(id) : '-'
        },
        emp_id() {
            return this.$store.getters['loginUser/getLocalEmployee']
        },
        printing() {
            return this.$store.getters['label/getIsPrinting']
        },

        user() {
            var employee = this.$store.getters['employee/getEmployee'](this.emp_id)

            if (employee) {
                return employee
            }
        },
        conn() {
            return this.$store.getters['getConnState']
        },

        clientLogo() {
            const location = this.$store.getters['login/getLocation']
            if (typeof location !== 'undefined') {
                return location.avatar
            } else {
                return ''
            }
        },

        pageTitle() {
            return this.$t('page_title.' + this.$route.name)
        },

        home() {
            return this.$store.getters['getHome'] ? this.$store.getters['getHome'] : '/home'
        },

        openedMenu() {
            return this.$store.state['menu_tools_is_expanded']
        },

        openedSubMenu() {
            return this.$store.state['submenu_tools_is_expanded']
        },

        showingUser() {
            return this.$store.state['menu_user_is_visible']
        },

        settingsAvailable() {
            return this.$store.getters.getSettingsAvailable
        },

        showSync() {
            return this.settingsAvailable && this.$store.getters['getSyncFlag']
        },
        renewLicense() {
            return this.$store.getters['getLicenseEndDate']
        },
        withAlerts() {
            let config = this.$store.getters['login/getConfig']
            if (config && (typeof config.show_alerts == 'undefined' || !config.show_alerts)) return false
            const sensorHome = this.$store.getters['sensor/getSensorHome']
            let issues = this.$store.getters['getAlertsActive']
            let alerts = sensorHome.alerts
            let inactive = sensorHome.inactive
            let turnedOff = sensorHome.turned_off
            let active = alerts > 0 || inactive > 0 || turnedOff > 0
            for (var key in issues) {
                if (!active && issues[key] > 0) active = true
            }
            return active
        }
    },
    methods: {
        // TOOLS
        toggleMenu() {
            this.auditorLocationMenuOpen = false
            if (this.openedMenu) {
                this.$store.commit('setMenuToolsExpanded', false)
            } else {
                this.$store.commit('setMenuToolsExpanded', true)
                this.$store.commit('setSubMenuToolsExpanded', false)
                this.$store.commit('setMenuUserVisible', false)
            }
        },

        SubMenuToggle() {
            this.auditorLocationMenuOpen = false
            if (this.openedSubMenu) {
                this.$store.commit('setSubMenuToolsExpanded', false)
            } else {
                this.$store.commit('setSubMenuToolsExpanded', true)
                this.$store.commit('setMenuToolsExpanded', false)
                this.$store.commit('setMenuUserVisible', false)
            }
        },

        // USER
        toggleUser() {
            this.auditorLocationMenuOpen = false
            if (this.showingUser) {
                this.$store.commit('setMenuUserVisible', false)
            } else {
                this.$store.commit('setMenuUserVisible', true)
                this.$store.commit('setSubMenuToolsExpanded', false)
                this.$store.commit('setMenuToolsExpanded', false)
            }
        },

        onAuditorLocationHeaderClick() {
            if (!this.canAuditorChangeLocal) {
                return
            }
            this.toggleAuditorLocationMenu()
        },

        toggleAuditorLocationMenu() {
            if (this.auditorLocationMenuOpen) {
                this.auditorLocationMenuOpen = false
            } else {
                this.auditorLocationMenuOpen = true
                this.$store.commit('setMenuToolsExpanded', false)
                this.$store.commit('setSubMenuToolsExpanded', false)
                this.$store.commit('setMenuUserVisible', false)
            }
        },

        closeAuditorLocationMenu() {
            this.auditorLocationMenuOpen = false
        },

        changeLocalFromAuditorHeader(event) {
            event.preventDefault()
            event.stopPropagation()
            this.auditorRunChangeLocal(() => {
                this.auditorLocationMenuOpen = false
            })
        },

        // GENERAL METHODS

        redirectPath(firstResult) {
            // console.log('redirect')
            return this.$root.redirectPath(firstResult)
        },

        toCurrentRoute() {
            let currentPath = this.$route.path
            let aux = this.$route.path.split('/')[1]
            let parentPath = typeof aux !== 'undefined' ? '/' + aux : false

            if (parentPath && parentPath != currentPath) {
                this.$router.push({ path: parentPath })
            }
        },

        openPrintQueue() {
            this.$router.push({ name: 'LabelQueue', params: { queue: 1 } }).catch((err) => {})
        },
        openStatusPage() {
            if (!this.settingsAvailable) return

            if (!fnCheckConnection()) {
                this.$popup.alert({
                    message: this.$t('sync.sync_error_offline')
                })
                return
            }
            this.$router.push({ name: 'ConfigPage', params: { page: 'status' } }).catch((err) => {})
        },
        openAndyAgents() {
            if (!this.emp_id || this.$route.name === 'AndyAgents') {
                return
            }

            this.$router.push({ name: 'AndyAgents' }).catch((err) => {
                if (err.name !== 'NavigationDuplicated') {
                    logError(err)
                }
            })
        }
    }
}
</script>

// PORTRAIT STYLES
<style lang="scss">
#menu-top-portrait {
    --mtp-h: 60px;
    @include display-flex();
    @include align-items();
    @include justify-content(space-between);
    position: fixed;
    top: 0;
    right: 0;
    z-index: $z-menu-top;
    // z-index: 1899999;
    height: var(--mtp-h);
    width: 100%;
    // transition-duration: 0.4s;
    background-color: $inactive-light;

    &.menu-top-portrait--auditor-local {
        --mtp-h: 56px;
        background-color: #fff;
    }

    .menu-icon {
        @include background($image: img('menu_toggle.svg'), $size: 40px, $position: center center);
        height: var(--mtp-h);
        width: var(--mtp-h);
        cursor: pointer;
        padding: calc((var(--mtp-h) - 40px) / 2);
        position: relative;

        &.renew {
            &::after {
                /* Notification img */
                @include background($image: img('renew_portrait.svg'), $size: 20px, $position: center center);
                content: '';
                position: absolute;
                top: 5%;
                right: 1%;
                width: 20px;
                height: 20px;
            }
        }
    }

    .title-menu,
    .customer-logo,
    .user-menu {
        height: 100%;
        display: inline-block;
    }

    .title-menu {
        max-width: calc(100% - (3 * var(--mtp-h)));
        width: calc(100% - (3 * var(--mtp-h)));
        height: var(--mtp-h);
        text-align-last: center;

        &.sync {
            &.offline {
                padding-left: var(--mtp-h);
            }
        }

        .page-title {
            @include font-size(s);
            @include text-ellipsis();
            height: 100%;
        }

        .sub-menu {
            @include display-flex();
            @include justify-content();
            @include align-items();
            @include flex-direction(column);
            height: 100%;
            cursor: pointer;

            .title {
                @include font-size(11px, $important: true);
                @include text-ellipsis();
                font-family: $text-light !important;
                text-transform: uppercase;
            }

            .sub-title {
                @include font-size(sm);
                @include background($image: img('down_caret_dark.svg'), $position: right center, $size: 8px);
                @include text-ellipsis();
                -webkit-appearance: none;
                -moz-appearance: none;
                padding-right: 15px;
                font-family: $text-bold;
                line-height: 25px;

                &.opened {
                    @include background($image: img('up_caret_neutro_s90.svg'), $position: right center, $size: 8px);
                }
            }
        }
    }

    .page-title {
        @include font-size(m, $important: true);
        line-height: var(--mtp-h);
        height: fit-content !important;
        margin: 0 auto;
    }

    .customer-logo {
        @include display-flex();
        @include justify-content();
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center center;
        width: calc(100% - var(--mtp-h) - var(--mtp-h) - 20px);
        height: calc(var(--mtp-h) - 20px) !important;
    }

    &.has-andy-agents {
        .title-menu,
        &.offline .title-menu,
        &.printer .title-menu {
            max-width: calc(100% - (3 * var(--mtp-h)) - #{rem(44px)});
            width: calc(100% - (3 * var(--mtp-h)) - #{rem(44px)});
        }

        .customer-logo {
            width: calc(100% - (2 * var(--mtp-h)) - #{rem(44px)} - 20px);
        }
    }

    .header-actions {
        @include display-flex();
        @include align-items(center);
        flex-shrink: 0;
    }

    .andy-agents-button {
        @include display-flex();
        @include align-items(center);
        @include justify-content(center);
        flex-shrink: 0;
        width: rem(44px);
        height: rem(44px);
        margin: 0;
        padding: 0;
        border: 0;
        background: transparent;
        cursor: pointer;
    }

    .user-avatar {
        min-width: var(--mtp-h);
        width: var(--mtp-h);
        height: var(--mtp-h);
        padding: 5px;
        cursor: pointer;

        .main-img {
            width: calc(var(--mtp-h) - 10px);
            height: calc(var(--mtp-h) - 10px);
        }
    }

    .sync-icon {
        @include display-flex();
        @include background($image: img('offline/sync.svg'), $size: 50px, $position: center center);
        height: var(--mtp-h);
        width: var(--mtp-h);
        min-height: var(--mtp-h);
        min-width: var(--mtp-h);
        padding: calc((var(--mtp-h) - 50px) / 2);
        cursor: pointer;
    }

    &.offline {
        .title-menu {
            @include text-ellipsis();
            max-width: calc(100% - (3 * var(--mtp-h)));
            width: calc(100% - (3 * var(--mtp-h)));
            padding-right: var(--mtp-h);

            &.offline {
                padding-left: 0px;
            }

            &.sync {
                padding-right: 0px;
            }
        }
        .offline-icon {
            @include display-flex();
            @include background($image: img('offline/no_wifi.svg'), $size: 40px, $position: center center);
            height: var(--mtp-h);
            width: var(--mtp-h);
            min-height: var(--mtp-h);
            min-width: var(--mtp-h);
            padding: calc((var(--mtp-h) - 40px) / 2);
        }
    }
    &.printer {
        .title-menu {
            @include text-ellipsis();
            max-width: calc(100% - (3 * var(--mtp-h)));
            width: calc(100% - (3 * var(--mtp-h)));
            padding-left: var(--mtp-h);
        }
        .printer-icon {
            @include display-flex();
            @include background($image: img('print_portrait.svg'), $size: 50px, $position: center center);
            height: var(--mtp-h);
            width: var(--mtp-h);
            padding: calc((var(--mtp-h) - 50px) / 2);
            margin-right: 0px;
            cursor: pointer;
            // animation: pulse 2s infinite;

            @keyframes pulse {
                0% {
                    transform: scale(0.95);
                    // box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);
                }

                70% {
                    transform: scale(1);
                    // box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
                }

                100% {
                    transform: scale(0.95);
                    // box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
                }
            }
        }
    }

    .auditor-location {
        @include display-flex();
        @include justify-content();
        @include align-items();
        @include flex-direction(column);
        text-align: center;
        text-align-last: center;

        .auditor-location-trigger {
            cursor: pointer;
            max-width: 100%;
            padding: 0 4px;

            &.is-readonly {
                cursor: default;
            }
        }

        .auditor-location-name {
            @include font-size(10px, $important: true);
            @include text-ellipsis();
            font-family: $text-light !important;
            color: #2a2a2a;
            text-transform: uppercase;
            line-height: 1.25;
            max-width: 100%;
        }

        .auditor-location-id {
            @include display-flex();
            @include align-items(center);
            @include justify-content(center);
            flex-wrap: nowrap;
            gap: 0;
            margin-top: 3px;
            max-width: 100%;
            min-height: 22px;
            padding: 2px 0;
            box-sizing: border-box;

            .auditor-location-id-text {
                font-size: 1.125rem !important;
                line-height: 22px !important;
                font-family: $text-bold, sans-serif !important;
                font-weight: 700 !important;
                color: #000000 !important;
                letter-spacing: 0;
                margin-right: 7px;
                @include text-ellipsis();
                flex: 0 1 auto;
                min-width: 0;
            }

            .auditor-location-caret {
                flex-shrink: 0;
                width: 8px;
                height: 8px;
                align-self: center;
                @include background($image: img('down_caret_dark.svg'), $position: center center, $size: 8px);
            }

            &.opened .auditor-location-caret {
                @include background($image: img('up_caret_neutro_s90.svg'), $position: center center, $size: 8px);
            }

            &.auditor-location-id--static {
                gap: 0;
            }
        }
    }

    .auditor-location-backdrop {
        position: fixed;
        top: var(--mtp-h);
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.35);
        z-index: 1;
    }

    /* Franja #f4f2ed + tarjeta blanca (Figma: 8110:107 + 8110:610) */
    .auditor-location-dropdown-sheet {
        position: fixed;
        top: var(--mtp-h);
        left: 0;
        right: 0;
        z-index: 2;
        box-sizing: border-box;
        min-height: 80px;
        padding: 15px 19px;
        background-color: #f4f2ed;
        @include display-flex();
        @include justify-content();
        @include align-items();
    }

    .auditor-location-dropdown {
        position: relative;
        top: auto;
        left: auto;
        transform: none;
        width: 100%;
        max-width: 321px;
        background-color: #fff;
        @include border-radius(5px);
        @include box-shadow(0, 2px, 8px, 0, rgba(0, 0, 0, 0.08));
        padding: 0;
        overflow: hidden;
    }

    .auditor-location-option {
        @include display-flex();
        @include align-items();
        padding: 10px 12px;
        min-height: 50px;
        box-sizing: border-box;
        cursor: pointer;

        .icon {
            width: 40px;
            height: 30px;
            flex-shrink: 0;
            @include background($image: img('change_local.svg'), $position: center center, $size: 20px);
        }

        .text {
            /* Figma 8110:615: 20px Regular, #222 */
            font-family: $text-light, sans-serif;
            font-weight: 400;
            font-size: 20px !important;
            font-size: 1.25rem !important;
            line-height: 30px;
            color: #222222;
        }
    }

    &.auditor-location-menu-open {
        z-index: $z-menu-top + 5;
    }
}

.app-safe-area {
    #menu-top-portrait {
        top: env(safe-area-inset-top);
    }
}
</style>
